export const navigationRoutes = {
  root: {
    name: "/",
    displayName: "navigationRoutes.home",
  },
  routes: [
    {
      name: "dashboard",
      displayName: "menu.dashboard",
      meta: {
        iconClass: "vuestic-iconset vuestic-iconset-dashboard",
      },
    },
    {
      name: "teachers",
      displayName: "导师管理",
      meta: {
        iconClass: "vuestic-iconset vuestic-iconset-forms",
      },
      children: [
        {
          name: "listTeacher",
          displayName: "menu.listTeacher",
        },
        {
          name: "teacherFrom",
          displayName: "导师来自",
        },
      ],
    },
    {
      name: "students",
      displayName: "学员管理",
      meta: {
        iconClass: "vuestic-iconset vuestic-iconset-files",
      },
      children: [
        {
          name: "listStudent",
          displayName: "学员故事",
        },
        {
          name: "studentOffer",
          displayName: "学员offer",
        },
        {
          name: "listOfferManage",
          displayName: "offer管理",
        },
      ],
    },
    {
      name: "services",
      displayName: "服务管理",
      meta: {
        iconClass: "vuestic-iconset vuestic-iconset-components",
      },
      children: [
        {
          name: "listService",
          displayName: "服务列表",
        },
        {
          name: "onlineAction",
          displayName: "在线项目实战",
        },
        {
          name: "enterpriseToOne",
          displayName: "名企一对一",
        },
        {
          name: "enterprisePracticeResource",
          displayName: "企业实习资源",
        },
      ],
    },
    {
      name: "news",
      displayName: "篱笆资讯",
      meta: {
        iconClass: "vuestic-iconset vuestic-iconset-statistics",
      },
      children: [
        {
          name: "listNews",
          displayName: "资讯列表",
        },
      ],
    },
    {
      name: "problem",
      displayName: "问题管理",
      meta: {
        iconClass: "vuestic-iconset vuestic-iconset-settings",
      },
      children: [
        {
          name: "listCommonQuestion",
          displayName: "常见问题",
        },
        {
          name: "listFeedback",
          displayName: "学员反馈",
        },
      ],
    },
    {
      name: "interviewQuestion",
      displayName: "面经管理",
      meta: {
        iconClass: "vuestic-iconset vuestic-iconset-forms",
      },
      children: [
        {
          name: "listInterviewQuestion",
          displayName: "面经列表",
        },
        {
          name: "listOrganization",
          displayName: "企业列表",
        },
      ],
    },
    {
      name: "tag",
      displayName: "标签管理",
      meta: {
        iconClass: "vuestic-iconset vuestic-iconset-forms",
      },
      children: [
        {
          name: "listPositionTag",
          displayName: "职位标签列表",
        },
      ],
    },
    {
      name: "mentors",
      displayName: "篱笆留学",
      meta: {
        iconClass: "vuestic-iconset vuestic-iconset-forms",
      },
      children: [
        {
          name: "listMentor",
          displayName: "留学导师列表",
        },
        {
          name: "listSuccessCase",
          displayName: "留学成功案例",
        },
        {
          name: "listRecentNews",
          displayName: "留学最新动态",
        },
        {
          name: "listStudentStory",
          displayName: "留学学员故事",
        },
        {
          name: "listPost",
          displayName: "留学文章管理",
        },
      ],
    },
  ],
};
